<template>
	<v-dialog v-model="dialog" max-width="600">
		<template v-slot:activator="{ on, attrs }">
			<v-btn color="secondary" class="ml-2" v-bind="attrs" v-on="on">
				<v-icon class="mr-1">mdi-plus</v-icon>
				新規材料追加
			</v-btn>
		</template>
		<v-card>
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white" class="color-white"> 新規材料追加 </v-toolbar-title>
				<v-spacer />
				<v-btn icon dark @click="closeDialog" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<div class="pa-2">
				<div>
					<table width="100%" class="show-dialog-table show-dialog-table--form">
						<tbody>
							<ShowDetailRecord :columnName="'材料名'">
								<template v-slot:value>
									<v-text-field
										v-model="TODO"
										background-color="white"
										:rules="[rules.required]"
										dense
										outlined
										hide-details
									/>
								</template>
							</ShowDetailRecord>
							<ShowDetailRecord :columnName="'登録種類'">
								<template v-slot:value>
									<v-select
										:items="types"
										item-text="name"
										item-value="value"
										v-model="TODO"
										background-color="white"
										:rules="[rules.required]"
										dense
										outlined
										hide-details
									/>
								</template>
							</ShowDetailRecord>
						</tbody>
					</table>
				</div>
			</div>
			<v-card-actions>
				<v-row no-gutters>
					<v-col sm="2" cols="0" />
					<v-col sm="8" cols="12" class="text-center">
						<v-btn color="secondary" @click="createItem">
							<v-icon class="mr-1">mdi-plus</v-icon>
							作成する
						</v-btn>
					</v-col>
					<v-col sm="2" cols="0" class="text-right">
						<v-btn v-if="!$vuetify.breakpoint.xs" color="grey darken-1" text @click="closeDialog">
							キャンセル
						</v-btn>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import rules from "../../../helper/rules"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"

export default {
	components: {
		ShowDetailRecord,
	},
	data() {
		return {
			rules,
			TODO: null,
      dialog: false,
			types: [
				{ value: "rubber", name: "ゴム" },
				{ value: "item_kg", name: "その他(kg管理)" },
				{ value: "item_quantity", name: "その他(数量管理)" },
			],
		}
	},
	methods: {
		createItem() {
			// TODO:
			this.$emit("create-item", this.TODO)
			this.closeDialog()
		},
		closeDialog() {
			this.dialog = false
		},
	},
}
</script>